import { Str } from '@livecontrol/core-utils';
import { EventValidator } from './types';

export const validateMobileEventDescription = (
  newEventInfo: EventValidator.EventInfo
): EventValidator.Errors => {
  const errors: EventValidator.Errors = {};
  const description = Str.normalize(newEventInfo.mobileKitData?.description);

  if (!!description && description.length > 7500) {
    errors.mobileKitData ??= {};
    errors.mobileKitData.description = EventValidator.ErrorMessages.DESCRIPTION_TOO_LONG;
  }

  return errors;
};
